// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import {FormBlock} from "./form_block";
import isPresent from 'is-present'
import Moment from 'moment-timezone'

class FormPart extends Model {
  defaults() {
    return {
      form_blocks: []
    }
  }
  mutations() {
    return {
      form_blocks: (arr)=>{ return arr.map(e=>{let o=new FormBlock(e); o.form_part=this; return o})},
    }
  }
  has_many_block_styles(){
    return this.program.builder[this.style]["blocks"].length > 1
  }
  main_form_block(){
    if (this._main_form_block) return this._main_form_block

    if (this.style === 'Parent'){
      return this._main_form_block = this.form_blocks.find(fb=>fb.style === 'Product::FormBlock::PartParent')
    }else {
      return this._main_form_block =  this.has_many_block_styles() ? null : this.form_blocks[0]
    }
  }

  to_display(){
    return this.form_blocks.some((fb)=>fb.to_display())
  }
  // has_custom_fields(){
  //   return !["Medication"].includes(this.style)
  // }

}

export {
  FormPart
}